'use strict';
var $ = require('jquery');
var btnOpen = $('.js-coffee');
var btnClose = $('.kaffe-popup__close');
var popup = $('.kaffe-popup-overlay');

function init() {
  $(btnOpen).on('tap click', function(){
    showHideCoffee();
  });

  $(btnClose).on('tap click', function(){
    showHideCoffee();
  });

  bindClickDetection();
}

function showHideCoffee() {
  if( $(popup).hasClass('-hidden') ) {

    $(popup).removeClass('-hidden');
    setTimeout(function(){
      $(popup).toggleClass('-hidden-opacity');
    }, 10);

  }else {

    $('.js-body').unbind('click');
    $('.js-kaffe-popup').unbind('click');

    $(popup).toggleClass('-hidden-opacity');
    setTimeout(function(){
      $(popup).toggleClass('-hidden');
    }, 300);

  }

  bindClickDetection();
}

function bindClickDetection() {

  $('.js-body').on('tap click', function() {
    if( !$(popup).hasClass('-hidden') ) {
      showHideCoffee();
    }
  });

  $('.js-kaffe-popup').on('tap click', function(e) {
    e.stopPropagation();
  });
}

module.exports = init();



// WEBPACK FOOTER //
// ./components/coffee_popup.js